import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import ComparisonSection from './components/ComparisonSection';
import FeaturesSection from './components/FeaturesSection';
import SEOSection from './components/SEOSection';
import BlogPreviewSection from './components/BlogPreviewSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yoybuyspreadsheet.top';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'YOYBUY Spreadsheet',
  url: siteUrl,
  description: 'YOYBUY Spreadsheet — самая полная таблица для закупок из Китая. Сравнение платформ YOYBUY, Kakobuy и Superbuy. Управляйте закупками, анализируйте поставщиков и минимизируйте риски.',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
  sameAs: ['https://kaspreadsheet.com'],
  foundingDate: '2026',
  areaServed: {
    '@type': 'Country',
    name: 'Russia',
  },
};

const webSiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'YOYBUY Spreadsheet',
  url: siteUrl,
  description: 'YOYBUY Spreadsheet — самая полная таблица для закупок из Китая. Сравнение платформ YOYBUY, Kakobuy и Superbuy.',
  inLanguage: 'ru',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <JsonLd data={organizationJsonLd} />
      <JsonLd data={webSiteJsonLd} />
      <main>
        <HeroSection />
        <CategoriesSection />
        <ComparisonSection />
        <FeaturesSection />
        <SEOSection />
        <BlogPreviewSection />
        <CTASection />
        <FAQSection />
        <Footer />
      </main>
    </>
  );
}